import React, { Component } from 'react'; 
import Toggle from "react-toggle";
import axios from '../../axios';
import * as url from '../../utils/url';
import findIndex from 'lodash/findIndex';
import Checkbox from 'rc-checkbox';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'; 
import * as actionCreators from '../../modules/actions/index';
import moment from 'moment';
import AttendeeItem from './AttendeeItem';
import {groupContentFields, groupPrivacyStatusDesc,uploadPreview,whiteLabelStyling, eventRoles, is_event_past, profilePicValidityCheck} from  '../../utils/constants';
import { Modal, ModalBody,ModalHeader, Alert, Button, Label, Dropdown, DropdownItem, DropdownToggle, DropdownMenu, Row, Col, Input } from 'reactstrap'
import './EventGuestListModal.css'


class InvitedList extends Component {

	constructor(props) {
    super(props);
			this.state = { 
				results:[],
        curr_menu:0,
        isSuccess:false,removedItem:null
		  }
    }


    

viewMember=user=>{
  let link = `/home/${user.organizationId}/profile/${user._id}`
  this.props.history.push(link);
}
 
getInitials=(user)=>{
  let firstName = user.firstName &&user.firstName.length>0?user.firstName:'N'
  let lastName = user.lastName &&user.lastName.length>0?user.lastName:'N'
  return firstName.charAt(0).toUpperCase()+ lastName.charAt(0).toUpperCase() 
}


menuClick=curr_menu=>{
  this.setState({curr_menu})
}


 
is_user_owner = (userId) =>{
  let{event}=this.props
  if(event){
    let{createdBy}=event
    if(createdBy&&createdBy._id==userId) return true
  }
  return false
}

	render() {
       let{results}=this.props
    console.log('results --- ', results)
       return (
        <ul className="">
        {/* <li className="table-header dashboardHeader"   >
          <div className="col col-6">Profile</div>
          <div className="col col-5">Role</div>
          <div className="col col-1"></div>
        </li> */}


        { results.map((item,idx) => {
          let user = item.userId
          if(user && user._id){
            return (
              <li className={`${this.props.is_module=='RSVP'?'rsvp_modal_list_container':''} event_user_rows`} key={user._id}>
                
                 <div className="col col-12" data-label="Name">
                    <div className="grp_member_profile_image">
                        {profilePicValidityCheck(user.profilePic) ?
                        <div className="list-item__avatar">
                          <img src={user.profilePic} />
                        </div>
                          :
                              <span className="list-item__avatar" data-letters={this.getInitials(user)}></span>
                            }
                    </div>
                    <div className="grp_member_profile_details">
      
                        <div className="linkedToolView" onClick={()=>this.viewMember(user)}> {user.firstName} ,  {user.lastName}</div>
                        
                        <div className="grp_member_profile_joined">invited {moment(item.date).format('MMM Do, YYYY')} </div>
                        
                    </div>


                   {this.props.canRemove && !this.is_user_owner(user._id) && is_event_past(this.props.event)? 
                   <span onClick={()=>this.props.removeRsvp(user, true, 'invitee_count',item)} 
                   className={`chart-item-menu ${this.props.curr_menu!=3?'flaticon-trash':'flaticon-refresh-1'}`}/> :null}
                 

                  </div>
                  

                  {/* <div className="col col-5" data-label="Role">
                    {(eventRoles.filter(e=>e.value==item.role.value)).label}
                  </div> */}

 
              </li> 

            )}
        })}
      
      </ul>
        
       )
	}
}

const mapStateToProps = state => {
	return {
    user: state.user.profile,
	};
};


const mapDispatchToProps = dispatch => {
	return {
	  storyMetricsChange: (data) => dispatch(actionCreators.storyMetricsChange(data)),
	}
  }


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvitedList));


  
  